// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kD77","textarea":"styles_textarea__26l8g"};